/*@ngInject*/
module.exports = function ($timeout) {
    return {
        bindToController: true,
        controllerAs: 'infoBox',
        controller: ['$scope', '$document', function ($scope, $document) {
            // Assuming info box has a corresponding ID
            const infoBox = angular.element(document.querySelector('#top_info_box'));

            // Add a click event listener to the checkbox that toggles the info box
            $scope.toggleInfoBox = function () {
                if ($scope.infoBoxChecked) {
                    infoBox.css('display', 'block');
                    $timeout(() => {
                        $scope.setCloseFocus();
                    }, 0);
                } else  {
                    infoBox.css('display', 'none');
                    $timeout(() => {
                        $scope.setOpenFocus();
                    }, 0);
                }
            };

            $scope.closeInfobox = () => {
                $scope.infoBoxChecked = false;
                $scope.toggleInfoBox();
            };

            $scope.setCloseFocus = () => {
                document.querySelector('#closeInfoBox').focus();
            };
            $scope.setOpenFocus = () => {
                document.querySelector('#openInfoBox').focus();
            };

            // Add a keydown event listener to the document object
            $document.on('keydown', function (event) {
                if (event.keyCode === 27) {
                    if (document && document.activeElement &&  document.activeElement.getAttribute('class') && document.activeElement.getAttribute('class').includes('info-box')) {
                        $scope.$apply(function () {
                            $scope.infoBoxChecked = false;
                            infoBox.css('display', 'none');
                        });
                    }
                }
                if (document && document.activeElement &&  document.activeElement.getAttribute('class') && document.activeElement.getAttribute('class').includes('info-box')) {
                    if (event.key === 'Enter') {
                        $scope.$apply(function () {
                            $scope.infoBoxChecked = !$scope.infoBoxChecked;
                            $scope.toggleInfoBox();
                        });
                    }
                }
            });
        }]
    };
};



/** WEBPACK FOOTER **
 ** ./app/shared/directives/info-box.directive.js
 **/